module.exports = __webpack_public_path__ + "img/5.d3e705b6.webp";